import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { APP_CONFIG } from './app/shared/utils/config/app-config';
import { loadRemoteConfig } from './app/shared/utils/config/config-loader';
import { SessionConfigLoader } from './app/shared/utils/config/session-config-loader';

(async () => {
    const configUrl = sessionStorage.getItem('configUrl');
    const remoteConfig = await loadRemoteConfig(configUrl ?? undefined);

    const sessionConfigLoader = new SessionConfigLoader(sessionStorage);
    const comboConfig = sessionConfigLoader.mapRuntimeConfig(remoteConfig);

    bootstrapApplication(AppComponent, {
        providers: [{ provide: APP_CONFIG, useValue: comboConfig }, ...(appConfig.providers ?? [])],
        // eslint-disable-next-line no-console -- runs pre-bootstrap; Angular DI/NGXLogger unavailable
    }).catch((err) => console.error(err));
    // eslint-disable-next-line no-console -- runs pre-bootstrap; Angular DI/NGXLogger unavailable
})().catch((err) => console.error(err));
